import { faTag } from "@jewlr/pro-regular-svg-icons/faTag"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Shimmer from "components/ui/shimmer"
import { cn } from "styles/utils"

const SaleBadge = ({
  mobileSimplifyVariantExp = false,
  sale = false,
  ...props
}) => (
  <div
    className={cn(
      "bg-ruby inline-flex items-center justify-center py-4 font-bold uppercase text-white",
      mobileSimplifyVariantExp
        ? "text-12 tablet:text-14 tablet:leading-16 tablet:px-8 leading-14 px-4"
        : "text-14 leading-16 px-8",
      sale ? "rounded-md" : "rounded-xs",
      sale || mobileSimplifyVariantExp ? "tracking-wide" : "tracking-widest"
    )}
    {...props}
  />
)

SaleBadge.propTypes = {
  mobileSimplifyVariantExp: PropTypes.bool,
  sale: PropTypes.bool,
}

const Badge = () => {
  const { holdbackExp, pricing, priorityBadge, wizardLoading } = useSelector(
    (state) => ({
      // holidayDelivery: state.wizard.shipping?.main?.available_holiday_delivery,
      holdbackExp: state.experiment.holdback.variant_id,
      pricing: state.wizard.price_and_promo,
      priorityBadge: state.wizard.priorityBadge,
      wizardLoading: state.wizard.loading,
    })
  )

  if (wizardLoading || !Object.keys(pricing).length) {
    return (
      <Shimmer className="mb-10" style={{ height: "24px", width: "120px" }} />
    )
  }

  const isMobileSimplifyVariantExp = holdbackExp === 0

  if (priorityBadge) {
    return (
      <SaleBadge mobileSimplifyVariantExp={isMobileSimplifyVariantExp} sale>
        <FontAwesomeIcon
          className={cn(
            isMobileSimplifyVariantExp ? "text-8 tablet:text-16" : "text-16",
            "mr-6 text-white"
          )}
          icon={faTag}
        />
        {priorityBadge.label}
      </SaleBadge>
    )
    // } else if (holidayDelivery) {
    //   return (
    //     <SaleBadge sale>
    //       {sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday}{" "}
    //       Delivery
    //     </SaleBadge>
    //   )
  } else if (pricing.on_sale) {
    const percentageSavings = (
      ((pricing.regular_pricing - pricing.price_to_display) * 100) /
      pricing.regular_pricing
    ).toFixed(0)

    return (
      <SaleBadge mobileSimplifyVariantExp={isMobileSimplifyVariantExp}>
        SAVE {percentageSavings}% OFF
      </SaleBadge>
    )

    // return <SaleBadge>SALE</SaleBadge>
  } else return null
}

export default Badge
